import { Component, OnInit } from '@angular/core';

import { CommonService } from './services/common.service';
// Added: wheel/touch capture to stop nested scrollers behind modals/overlays
import { GlobalScrollBlockService } from './services/global-scroll-block.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'VitalHub';
  options={
    overlayClickToClose:false

  }
  constructor(
    public _commonService: CommonService,
   
    /** Instantiates {@link GlobalScrollBlockService} (capture-phase wheel/touch block behind overlays). */
    private readonly _globalScrollBlock: GlobalScrollBlockService
  ) {}

  // --- Added: lock main shell while Material dialogs are open (see VSstyles / directive) ---
  ngOnInit(): void {
   
}

 
}
